// Safari is hard-blocked regardless of version or getDisplayMedia presence — product decision
// to hide the Screen pill, matching Angular's checkScreenCaptureSupport behavior.
// iPadOS 15+ has getDisplayMedia and is deliberately allowed through.

type ScreenCaptureSupportResult =
  | { supported: true }
  | { supported: false; reason: "no-getDisplayMedia" | "safari" | "mobile" };

// /Safari/i matches desktop and Mobile Safari. Exclude Chrome/Chromium — they include "Safari" in UA.
export function isSafariUserAgent(ua: string): boolean {
  return /Safari/i.test(ua) && !/Chrome/i.test(ua) && !/Chromium/i.test(ua);
}

export function isScreenCaptureSupported(): ScreenCaptureSupportResult {
  if (
    typeof navigator === "undefined" ||
    !navigator.mediaDevices?.getDisplayMedia
  ) {
    return { supported: false, reason: "no-getDisplayMedia" };
  }

  if (isSafariUserAgent(navigator.userAgent)) {
    return { supported: false, reason: "safari" };
  }

  return { supported: true };
}
